import { createComponentMapperModel } from '@wix/editor-elements-integrations';
import { css } from '../../SiteButton/viewer/SiteButton.mapper';

export default createComponentMapperModel({ css });
